import {Link} from 'react-router-dom';
import {Tab} from '@mui/material';
import React from 'react';

function MenuItem({to, label}) {
    return <Tab component={Link} to={to} label={label}/>;
}

export default React.memo(MenuItem);